import reactDom from "react-dom";
import App from "./App";
import './index.css'
reactDom.render(<App/>,document.getElementById("root"))